export default "__VITE_ASSET__DoHugE6J__"